import api from './api';
import { API_BASE_URL } from '../config';

export const getAllConsultants = async () => {
    try {
        const response = await api.get(`/consultants/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching consultants:', error);
        throw error;
    }
};

export const getConsultant = async (id) => {
    try {
        const response = await api.get(`/consultants/${id}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching consultant:', error);
        throw error;
    }
};
